module.exports = __webpack_public_path__ + "statics/img/pia_s.png";